import { produce } from 'immer';

const arrayToNumberOrString = (arr: any[]) =>
  arr.map(v => {
    const num = Number(v);

    return Number.isInteger(num) ? num : v;
  });

const uniques = values => Array.from(new Set(values));

export default function addToState<T extends Record<string, any>>(
  state: T,
  name: string,
  value: string | number | number[] | string[],
) {
  return produce<T>(state, draft => {
    const detail = draft[name];

    if (detail && Array.isArray(detail)) {
      // @ts-expect-error
      draft[name] = uniques(arrayToNumberOrString(detail.concat(value)));
    } else if (Array.isArray(value)) {
      // @ts-expect-error
      draft[name] = uniques(arrayToNumberOrString(value));
    } else {
      // @ts-expect-error
      draft[name] = value;
    }
  });
}
